import dayjs from 'dayjs';
import 'dayjs/locale/fr';


export default {

  data () {
    return {
      authorization: null,
      toolTipVal: ''
    }
  },

  computed: {
    sortedAccountDetails() {
      const list = this.authorization?.accountDetailList?.accountDetail || [];
      return list.slice().sort((a, b) => {
        const caRaw = (a.accountCategory || 'Global').toString();
        const cbRaw = (b.accountCategory || 'Global').toString();
        return caRaw.localeCompare(cbRaw, undefined, { numeric: true, sensitivity: 'base' });
      });
    }
  },

  created () {
    this.authorization = this.$store.state.authorizations.authorizationDetail
    // On utilise un v-for pour afficher les data d'appel sae, pour des raisons d'affichage on veut le bloc vide si aucune donnée donc on remplit un élément du tableau avec des données vides
    if (!this.authorization) {
      this.$store.dispatch('authorizations/invalidData', 'AUTHORIZATION_EMPTY')
      this.$router.push({ name: 'authorization-list' })
    }
    else {
      this.$store.dispatch('authorizations/resetInvalidData')
      if (!this.authorization.saeCallData) {
        this.authorization.saeCallData = {}
        this.authorization.saeCallData[0] = {
          accountAvailable: '',
          amountAdjusted: '',
          extSaeRequestDate: '',
          extSaeResponseDate: '',
          opType: '',
          rejectNotificationReason: ''
        }
      }
    }
  },

  methods: {
    getToolTipText (id) {
      this.toolTipVal = '----- Autorisation initiale ----- \n'.concat(document.getElementById(id).innerText.replaceAll('<br>', '\r\n'))
    },

    // Dans les cas des appels sae externes, on peut avoir plusieurs objets
    getToolTipTextList (id) {
      this.toolTipVal = '----- Autorisation initiale ----- \n'
      for (let i = 0; i < this.authorization.oriAuthorization.saeCallData.length; i++) {
        this.toolTipVal += (document.getElementById(id + i).innerText.replaceAll('<br>', '\r\n'))
        if (i < this.authorization.oriAuthorization.saeCallData.length - 1) {
          this.toolTipVal += '---------------------\r\n'
        }
      }
    },

    downloadCSV () {
      const csv = this.loadCSV()
      const hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = dayjs().format('YYYYMMDD_HHmmss').concat('.csv')
      hiddenElement.click()
    },

    loadCSV () {
      const allColumns = (this.authorization && Object.keys(this.authorization)) || []
      const keys = this.filterColumns(allColumns)
      let csv = keys.map(this.getCSVHeaderLabel).join(';') + '\n'
      csv += keys.map(key => this.formatCSVValue(key, this.authorization[key])).join(';') + '\n'

      return csv
    },

    filterColumns (columnsArray) {
      return columnsArray.filter(function (ele) { return ele !== 'oriAuthorization' })
    },

    getCSVHeaderLabel (headerName) {
      return this.$i18n.t('label.authorization.detail.'.concat(headerName))
    },

    formatCSVValue (key, value) {
      switch (key) {
        case 'dateMoveUp':
        case 'dateTransaction':
        case 'oriDateTransaction':
          return value ? this.$filters.date(value) : value
        case 'dateTransmissionTransaction':
          return value ? this.$filters.dateTransmission(value) : value
        case 'amount':
        case 'solde':
        case 'actualAmount':
        case 'cardholderAmount':
        case 'complementAmount':
        case 'replacementAmount':
        case 'cardholderReplacementAmount':
          return value ? this.$filters.amount(value) : value
        default:
          return value
      }
    },

    translateOnlinePartialReversalParam (value) {
      switch (value) {
        case '0':
        case '1':
        case '2':
        case '3':
          return this.$i18n.t('label.authorization.detail.onlinePartialReversalParam'.concat(value))
        default:
          return value
      }
    }
  }
}
